import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Stream from 'flarum/utils/Stream';
import Button from 'flarum/components/Button';

export default class playVideoModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
  }

  className() {
    return 'Modal--medium';
  }

  title() {
    return [];
  }

  content() {
    const link = this.attrs.link;
    const height = ($(".u2diSubmitModalBody").width())*9/16;

    return [
      <div className="Modal-body u2diSubmitModalBody" style="text-align: center;">
        <div className="Form-group">
          <iframe style={"min-height: "+height+"px;width: 100%;"} src={"//player.bilibili.com/player.html?bvid="+link+"&&autoplay=1&muted=0"} scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
        </div>
      </div>
    ];
  }
}
